export default __webpack_public_path__ + "static/media/young-people.745278ac.jpg";